import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecutionList extends BaseModelAPI {

	static entity = 'workorderexecutionlist'
	static entityName = 'workorderexecution';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
